var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.429 1.714A3.422 3.422 0 0 0 0 5.143v13.714a3.422 3.422 0 0 0 3.429 3.429h13.714a3.422 3.422 0 0 0 3.429-3.429V5.143a3.422 3.422 0 0 0-3.429-3.429H3.429z"
  })));
};
export default SvgStop;